import request from '@/utils/request'

/**
 * 查询服务工单池列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryHousekeepingServPool(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServPool/queryHousekeepingServPool',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存电话预约服务
 * @param {Object} data 保存数据
 * @returns {Promise} Promise对象
 */
export function saveTelHousekeepingServ(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServPool/saveTelHousekeepingServ',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 工单派单
 * @param {Object} data 派单数据
 * @returns {Promise} Promise对象
 */
export function poolDispatch(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServPoolUser/poolDispatch',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}